import { api } from '@/lib/api/client';
import type { AuthTokens, Locale, User } from '@/lib/api/types';

export const authApi = {
  login(body: { email: string; password: string; totp_code?: string }): Promise<AuthTokens> {
    return api.post<AuthTokens>('/admin/auth/login', body);
  },
  forgot(email: string): Promise<{ status: string }> {
    return api.post('/admin/auth/forgot', { email });
  },
  reset(token: string, password: string): Promise<{ status: string }> {
    return api.post('/admin/auth/reset', { token, password });
  },
  // Self-service (spec §15.1a)
  updateMe(body: { name?: string; locale?: Locale }): Promise<User> {
    return api.patch<User>('/admin/me', body);
  },
  changePassword(body: { current_password: string; new_password: string }): Promise<null> {
    return api.post('/admin/me/password', body);
  },
  mfaEnroll(): Promise<{ secret: string; otpauth_url: string }> {
    return api.post('/admin/me/mfa/enroll');
  },
  mfaVerify(code: string): Promise<null> {
    return api.post('/admin/me/mfa/verify', { code });
  },
  mfaDisable(code: string): Promise<null> {
    return api.post('/admin/me/mfa/disable', { code });
  },
};
